<template>
  <div>
    <header class="header">
      <img src="../../assets/logo-header.svg" alt class="logo" />
      <nav>
        <a href class="back">返回首页</a>
        <span class="line"></span>
        <a href class="about">关于我们</a>
      </nav>
    </header>
    <div class="forgetPasswordBox">
      <div class="forgetContent">
        <span class="title">忘记密码</span>
        <div class="item phoneItem">
          <input
            type="text"
            id="loginPhoneFor"
            class="loginPhoneFor"
            v-model.trim="phone"
            maxlength="11"
            autocomplete ="off"
            placeholder="手机号"
          />
          <button id="btn-code">获取验证码</button>
        </div>
        <div id="awsc"></div>
        <input type="text" ref="forgetCode" v-model="verifyCode" class="item" placeholder="验证码" autocomplete ="off"/>
        <input type="password" id="loginPhonePassword" class="item" v-model.trim="newPassword"
               v-on:input="showStrength"
               placeholder="密码"
               autocomplete ="off"
        />
        <div v-bind:class="strengthClass" v-show="newPassword.length>0">
          <div class="passwordMain">
            <div class="passwordSpan passwordLow"><span class="act"></span></div>
            <div class="passwordSpan passwordMiddle"><span class="act"></span></div>
            <div class="passwordSpan passwordHigh"><span class="act"></span></div>
            <div class="passwordStrengthText passText">{{strengthName}}</div>
          </div>
        </div>
        <input type="password" id="loginPhonePasswordSure" class="item" v-model.trim="retypePassword" placeholder="确认密码" autocomplete ="off"/>
        <button class="resetBtn" v-on:click="doForget">修改密码</button>
      </div>
    </div>
    <footer class="footer">
      <dl class="first">
        <dl class="aboutUs">
          <dl>
            <dt>
              <a href target="_blank">直播场景</a>
            </dt>
            <dd>
              <a href target="_blank">大型活动</a>
            </dd>
            <dd>
              <a href target="_blank">内训会议</a>
            </dd>
            <dd>
              <a href target="_blank">在线教育</a>
            </dd>
            <dd>
              <a href target="_blank">金融直播</a>
            </dd>
            <dd>
              <a href target="_blank">营销推广</a>
            </dd>
            <dd>
              <a href target="_blank">网络视频</a>
            </dd>
          </dl>
          <dl>
            <dt>
              <a href target="_blank">技术支持</a>
            </dt>
            <dd>
              <a href target="_blank">直播百科</a>
            </dd>
            <dd>
              <a href target="_blank">软件下载</a>
            </dd>
          </dl>
          <dl>
            <dt>
              <a href target="_blank">购买服务</a>
            </dt>
            <dd>
              <a href target="_blank">硬件购买</a>
            </dd>
            <dd>
              <a href target="_blank">流量套餐</a>
            </dd>
          </dl>
          <dl>
            <dt>
              <a href target="_blank">关于我们</a>
            </dt>
            <dd>
              <a href target="_blank">复全网络</a>
            </dd>
            <dd>
              <a href target="_blank">联系我们</a>
            </dd>
          </dl>
          <div class="introduce">
            <div class="title">
              <img src="../../assets/logo-footer.png" alt class="logo" />
              <span class="line"></span>
              <span>企业直播平台</span>
            </div>
            <p
              class="desc"
            >QuickLive是专业的企业级云直播平台，拥有多终端超清直播和点播、互动分享、个性化设置、数据统计等100+优质功能，可为政府、企业、教育机构等各类用户提供低成本、高质量的一站式视频直播和点播服务。</p>
            <div class="key">电话</div>
            <div class="value">021-60135568-608</div>
            <div class="key">邮箱</div>
            <a
              class="value email"
              href="mailto:service@fortune-net.cn"
              target="_blank"
            >service@fortune-net.cn</a>
            <div class="key">地址</div>
            <div class="value">上海市杨浦区佳木斯路353号1502室</div>
            <div class="public">
              <img src="../../assets/public-qrcode.png" alt class="qrcode" />
              <span>QuickLive公众号</span>
            </div>
          </div>
        </dl>
      </dl>
      <div class="second">
        <div class="solution">
          <h2 class="title">我们还提供其他解决方案</h2>
          <div>
            <a href class="item firstItem" target="_blank">音视频采集分类管理系统 Redex Pro></a>
            <a href class="item" target="_blank">学员培训记录考核管理系统 SmartTraining></a>
          </div>
        </div>
      </div>
      <div class="last">
        <div class="copyright">
          <span class="firstItem">Copyright © 2017 Fortune Network All rights reserved.</span>
          <span>上海复全网络技术有限公司 沪B2-20220918</span>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import common from '../../common.vue';

const AWSC_SCENE = 'mdcab0v2';
const AWSC_PREFIX = '1r2b1e';
const SCENE = "message"
const STRENGTH_NAME_MAPPER = ['低', '低', '中', '高', '高'];
const STRENGTH_CLASS_MAPPER = ['PasswordStrength',
    'PasswordStrength passwordWrapLow',
    'PasswordStrength passwordWrapMiddle',
    'PasswordStrength passwordWrapHigh'];
const RESET_RESULT_MAPPER = ['密码重置成功，请使用新密码登录','信息不完整','无效的验证码', '验证码已过期', '账号不存在'];

export default {
    name: "ForgetPassword",
    mounted() {
        this.initAwsc();
    },
    data() {
        return {
            phone: '',
            newPassword: '',
            retypePassword: '',
            verifyCode: '',
            strengthName: '低',
            strengthClass: 'PasswordStrength',
        }
    },
    methods: {
        initAwsc() {
            let _this = this;
            window.initAliyunCaptcha({
                SceneId: AWSC_SCENE,
                prefix: AWSC_PREFIX,
                mode: 'popup',
                element: '#awsc',
                button: '#btn-code',
                captchaVerifyCallback: (verifyParams) =>{
                    _this.verifyParams = verifyParams;
                    return _this.sendCode();
                },
                onBizResultCallback: (bizResult) =>{
                    console.log(bizResult);
                },
                getInstance: (instance) =>{ _this.captcha = instance },
                slideStyle: { width: 400, height: 45},
                language: 'cn',
                region: 'cn'
            })
            // 实例化nc
            // AWSC.use("ic", function (state, module) {
            //     // 初始化
            //     window.nc = module.init({
            //         appkey: "FFFF00000000017876F0",
            //         scene: AWSC_SCENE,
            //         renderTo: "awsc",
            //         width: 400,
            //         default_txt: '点击发送验证码',
            //         success_txt: '验证码已发送',
            //         fail_txt: '人机验证失败，请在此点击按钮刷新',
            //         scaning_txt: '智能检测中',
            //         success: function (data) {
            //             if (!common.phoneValid(_this.phone)) {
            //                 _this.$message({
            //                     message: '请正确输入手机号',
            //                     type: 'warning',
            //                     duration: 1200,
            //                     onClose: () => {
            //                         window.nc.reset();
            //                         _this.captchaData = null;
            //                     }
            //                 });
            //             } else {
            //                 _this.captchaData = data;
            //                 _this.sendCode();
            //             }
            //         },
            //         // 验证失败时触发该回调参数
            //         fail: function (failCode) {
            //             console.log(failCode)
            //         },
            //         // 验证码加载异常时触发该回调参数
            //         error: function (errorCode) {
            //             console.log(errorCode)
            //         }
            //     });
            // })
        },
        /**
         * 显示密码强度
         */
        showStrength() {
            let strength = common.passwordStrength(this.newPassword);
            this.strengthName = STRENGTH_NAME_MAPPER[strength];
            this.strengthClass = STRENGTH_CLASS_MAPPER[Math.min(strength, STRENGTH_CLASS_MAPPER.length - 1)];
        },

        /**
         * 检查数据，提交重置密码
         */
        doForget() {
            let _this = this;
            if (!common.phoneValid(_this.phone)) {
                this.$message('请正确输入手机号');
                return;
            }
            if (this.verifyCode === '') {
                this.$message('请输入验证码');
                return;
            }
            if (this.newPassword !== this.retypePassword) {
                this.$message('密码和确认密码不一致，请重新输入');
                this.newPassword = '';
                this.retypePassword = '';
                return;
            }
            if (common.passwordStrength(this.newPassword) < 3) {
                this.$message({message:'至少选择大写字母、小写字母、数字、特殊字符中的三种，且长度不少于8位', type:'warning'});
                return;
            }
            // 提交重置
            let formData = Object.assign(
                {
                  phone: this.phone,
                    password: this.$md5(this.newPassword),
                    verifyCode:this.verifyCode,
                    scene: AWSC_SCENE
                }, this.captchaData);
            this.$axios.post(common._BASE_ + 'sponsor/reset', this.$qs.stringify(formData)).then(function (res) {
              res.data.code === 0 && _this.$message({
                  message: RESET_RESULT_MAPPER[0],
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                      //window.location.href = common.LOGON_URL;
                      _this.$router.push('/login');
                  }
              })
              res.data.code < 0 && _this.$message(RESET_RESULT_MAPPER[Math.abs(res.code)]);
            });
        },
        /**
         * 发送验证码
         */
        sendCode: async function () {
            let _this = this;
            if(!common.phoneValid(_this.phone)){
              _this.$message({
                  message: '请正确输入手机号',
                  type: 'warning',
                  duration: 1200
              });
              return {captchaResult: true, bizResult: false}
            }

            let data = {phone: _this.phone, scene: SCENE, sceneId: AWSC_SCENE, verifyParams: _this.verifyParams};
            let captchaResult = true, bizResult = true;
            await _this.$axios.post(common._BASE_ + 'sponsor/forgetCode', this.$qs.stringify(data)).then(function (res) {
                switch (res.data.code) {
                    case 0:
                        captchaResult = true;
                        bizResult = true;
                        _this.$message({
                            message: '验证码已发送',
                            type: 'success',
                            duration: 1200,
                            onClose: () => {
                                // _this.$refs.forgetCode.focus();
                                
                            }
                        });
                        break;
                    case 1:
                        captchaResult = false;
                        bizResult = false;
                        _this.$message({
                            message: '人机验证信息无效，请重试',
                            type: 'error',
                            duration: 1200,
                            onClose: () => {
                                // window.nc.reset();
                            }
                        });
                        break;
                    case 2:
                        captchaResult = true;
                        bizResult = false;
                        _this.$message({
                            message: '验证码发送失败，请重试',
                            type: 'error',
                            duration: 1200,
                            onClose: () => {
                                // window.nc.reset();
                            }
                        });
                }
            });
            return {captchaResult: captchaResult, bizResult: bizResult}
        }
    }
};
</script>
<style lang="less">
.header {
  width: 100%;
  height: 60px;
  padding: 0 19px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-weight: 400;
  color: #707070;
  background: #fff;
  a {
    color: #707070;
  }
  a:hover {
    color: #306ff6;
  }
  a.back {
    margin-right: 17px;
  }
  a.about {
    margin-left: 17px;
  }
  .line {
    display: inline-block;
    height: 14px;
    width: 1px;
    background: #c1c5c5;
  }
  .logo {
    width: 152px;
    cursor: pointer;
  }
}
.footer {
  height: 470px;
  background: #33363f;
  position: relative;
}

.footer .first {
  height: 327px;
  border-bottom: 1px solid #55565f;
  padding-top: 28px;
}

.footer .second {
  height: 92px;
  border-bottom: 1px solid #55565f;
}

.footer .last {
  height: 51px;
}

.footer .aboutUs,
.footer .solution,
.footer .copyright {
  width: 1000px;
  height: 100%;
  margin: 0 auto;
}

.footer .aboutUs {
  display: flex;
  position: relative;
}

.footer .aboutUs dl {
  width: 74px;
  margin-right: 48px;
  dd {
    margin-left: 0;
  }
}

.footer .aboutUs dl:last-child {
  margin-right: 0;
}

.footer .aboutUs dl dt > a {
  display: inline-block;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #f5f6f7;
  margin-bottom: 10px;
  cursor: pointer;
}

.footer .aboutUs dt:hover,
.footer .aboutUs dl a:hover,
.footer .introduce .email:hover,
.footer .solution .item:hover {
  color: #f5f6f7;
  text-decoration: underline;
}

.footer .aboutUs dl a {
  font-size: 12px;
  font-weight: 400;
  line-height: 26px;
  color: #a2a9ab;
}

.footer .introduce {
  width: 412px;
  position: absolute;
  right: 0;
}

.footer .introduce .title {
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.footer .introduce .title .logo {
  width: 207px;
}

.footer .introduce .title .line {
  width: 1px;
  height: 34px;
  background: #707070;
  margin: 0 9px;
}

.footer .introduce .desc {
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  color: #a2a9ab;
  margin-top: 16px;
  margin-bottom: 19px;
}

.footer .introduce .key {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #a2a9ab;
}

.footer .introduce .value {
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #f5f6f7;
}

.footer .introduce .public {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #ffffff;
  position: absolute;
  right: 0;
  top: 153px;
}

.footer .introduce .public .qrcode {
  width: 91px;
}

.footer .solution {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.footer .solution .title {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #f5f6f7;
  margin-bottom: 10px;
}

.footer .solution .item {
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #a2a9ab;
}

.footer .solution .item.firstItem {
  margin-right: 50px;
}

.footer .copyright {
  line-height: 51px;
  font-size: 12px;
  font-weight: 400;
  color: #7e868c;
  text-align: center;
}

.footer .copyright .firstItem {
  margin-right: 27px;
}
.forgetPasswordBox {
  height: 646px;
  background: #f5f6f7;
}

.forgetContent {
  width: 494px;
  height: 516px;
  background: #fff;
  margin: 120px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 41px;
}

.forgetContent .title {
  font-size: 24px;
  font-weight: bold;
  color: #33363f;
  margin-bottom: 21px;
}

.forgetContent .item {
  width: 400px;
  height: 45px;
  border: 1px solid #c0c5c5;
  margin-bottom: 14px;
  padding-left: 17px;
  font-size: 14px;
}

.forgetContent .item:focus {
  border: 1px solid #306ff6;
}

.forgetContent .phoneItem {
  display: flex;
  align-items: center;
  padding-left: 0;
}

.forgetContent .phoneItem input {
  width: 268px;
  padding-left: 17px;
  height: 100%;
}

.forgetContent .phoneItem input:focus {
  border: 1px solid #306ff6;
}

.forgetContent .phoneItem button {
  flex: 1;
  height: 100%;
  font-size: 12px;
  font-weight: 400;
  color: #7c868d;
  border-left: 1px solid #c0c5c5;
}

.forgetContent .phoneItem button:hover {
  background: #fff;
}

.forgetContent .resetBtn {
  width: 400px;
  height: 50px;
  background: #076eff;
  opacity: 1;
  border-radius: 4px;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
}

.forgetContent .resetBtn:hover {
  background: #4aa3f8;
}

#awsc{ margin-left: 0;padding: 0; border: 0 }

.PasswordStrength {
  width: 400px;
  height: 6px;
  margin-bottom: 14px;
  /*display: none;*/
}

.PasswordStrength .passwordMain {
  width: 400px;
  height: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.PasswordStrength .passwordSpan {
  width: 195px;
  height: 6px;
  background: #E4E4E4;
  margin-right: 2px;
}

.PasswordStrength .passwordHigh {
  margin-right: 8px;
}

.PasswordStrength .passwordSpan span {
  width: 100%;
  height: 100%;
  display: none;
}

.PasswordStrength.passwordWrapLow .passwordSpan.passwordLow span {
  display: block;
}

.PasswordStrength.passwordWrapMiddle .passwordSpan.passwordLow span,
.PasswordStrength.passwordWrapMiddle .passwordSpan.passwordMiddle span {
  display: block;
}

.PasswordStrength.passwordWrapHigh .passwordSpan span {
  display: block;
}

.passwordLow span {
  background: #FF352F;
}

.passwordMiddle span {
  background: #F9A713;
}

.passwordHigh span {
  background: #00A871;
}

.PasswordStrength .passText {
  font-size: 18px;
  color: #707070;
}

</style>
